import { QueryInterface } from "@qpr/client-api-base/querybuilder/QueryBuilder";
import { findYearsLastPeriod } from "./model/findYearsLastPeriod";
import { IPeriodLevel } from "./model/model";

type Params = Parameters<QueryInterface["attributes"]>;
type FParams = (
  period: string | undefined,
  allPeriods: IPeriodLevel[]
) => Params;

// prettier-ignore
const defaultAttributes: FParams = (period: string|undefined, allPeriods: IPeriodLevel[]) => {
  const lastPeriod = period && allPeriods ? findYearsLastPeriod(period, allPeriods) : undefined;  
    const items = [

    // Common series
    "name",
    "periodlevel",
    "periodlevelid",
    "description",
    "symbol",
    "periodlevelname",
    "owner",
    "topelement",
    "level",
    "childobjects",
    ["scorecard.name", { as: "scorecardname" }],
    ["scorecard.symbol", { as: "scorecardsymbol" }],

    // rangecolor can also be queried using
    // measure.rangecolor(series="EXECUTION", as="card_rangecolor", period="{#_SELECTED_PERIOD}")

    ["rangecolor", { period: period, as: "rangecolor" }],
    ["rangename", { period: period, as: "rangename" }],
    ["rangevalue", { period: period, as: "rangevalue" }],

    ["rangecolor", { period: period, as: "rangecolor_default" }],
    ["rangename", { period: period, as: "rangename_default" }],
    ["rangevalue", { period: period, as: "rangevalue_default" }],
    ["value", { period: period, series:"STATUS",as: "STATUS" }],

    ["rangename", { period: period, series:"PERF_OPEN",as: "rangename_KPI" }],
    ["rangevalue", { period: period, series:"PERF_OPEN",as: "rangevalue_KPI" }],
    ["value", { as: "STD_PERF", period }],
    ["value", { series: "PERF", as: "PERF", period }],
    ["prettyvalue", { series: "PERF", as: "PERF_prettyvalue", period }],

    ["rangename", { period: period, series:"PERF_OPEN", as: "rangename_KPI" }],
    ["rangevalue", { period: period, series:"PERF_OPEN", as: "rrangevalue_KPI" }],
    ["rangecolor", { period: period, series:"PERF_OPEN", as: "rangecolor_KPI" }],

    ["rangename", { period: period, series:"PERF_YTD_OPEN", as: "rangename_PERF_YTD_OPEN" }],
    ["rangevalue", { period: period, series:"PERF_YTD_OPEN", as: "rangevalue_PERF_YTD_OPEN" }],
    ["rangecolor", { period: period, series:"PERF_YTD_OPEN", as: "rangecolor_PERF_YTD_OPEN" }],

    ["rangename", { period: period, series:"PERF_W_YTD", as: "rangename_PERF_W_YTD" }],
    ["rangevalue", { period: period, series:"PERF_W_YTD", as: "rangevalue_PERF_W_YTD" }],
    ["rangecolor", { period: period, series:"PERF_W_YTD", as: "rangecolor_PERF_W_YTD" }],

    ["rangename", { period: period, series:"PERF_AVG_YTD", as: "rangename_PERF_AVG_YTD" }],
    ["rangevalue", { period: period, series:"PERF_AVG_YTD", as: "rangevalue_PERF_AVG_YTD" }],
    ["rangecolor", { period: period, series:"PERF_AVG_YTD", as: "rangecolor_PERF_AVG_YTD" }],

    ["measure.parent.name", { as: "parentName" }],
    ["measure.parent.typename", { as: "parentTypename" }],
    ["measure.parent.description", { as: "parentDescription" }],

    // [26/01 13.04] Toni Kaikkonen (EXT)
    // ACT_YTD, TAR_YTD ja PERF_YTD. 
    ["value", { series: "ACT_YTD", as: "ACT_YTD", period }],
    ["value", { series: "TAR_YTD", as: "TAR_YTD", period }],
    ["value", { series: "PERF_YTD", as: "PERF_YTD", period }],
    ["unit", { series: "ACT_YTD", as: "ACT_YTD_unit", period }],
    ["unit", { series: "TAR_YTD", as: "TAR_YTD_unit", period }],
    ["unit", { series: "PERF_YTD", as: "PERF_YTD_unit", period }],
    ["unit", { series: "PERF_YTD", as: "PERF_YTD_unit", period }],
    ["valuewithoutsymbol", { series: "ACT_YTD", as: "ACT_YTD_valuewithoutsymbol", period }],
    ["valuewithoutsymbol", { series: "TAR_YTD", as: "TAR_YTD_valuewithoutsymbol", period }],
    ["valuewithoutsymbol", { series: "PERF_YTD", as: "PREF_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "TAR_YTD", as: "TAR_YTD_prettyvalue", period }],
    ["prettyvalue", { series: "ACT_YTD", as: "ACT_YTD_prettyvalue", period }],
    ["prettyvalue", { series: "PERF_YTD", as: "PERF_YTD_prettyvalue", period }],

    ["value", { series: "PERF_W_YTD", as: "PERF_W_YTD", period }],
    ["prettyvalue", { series: "PERF_W_YTD", as: "PERF_W_YTD_prettyvalue", period }],
    ["valuewithoutsymbol", { series: "PERF_W_YTD", as: "PERF_W_YTD_valuewithoutsymbol", period }],
    ["unit", { series: "PERF_W_YTD", as: "PERF_W_YTD_unit", period }],

    ["value", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN", period }],
    ["prettyvalue", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_prettyvalue", period }],
    ["valuewithoutsymbol", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_valuewithoutsymbol", period }],
    ["unit", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_unit", period }],

    ["value", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD", period }],
    ["prettyvalue", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_prettyvalue", period }],
    ["valuewithoutsymbol", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_valuewithoutsymbol", period }],
    ["unit", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_unit", period }],

    ["value", { series: "W", as: "W", period }],
    ["prettyvalue", { series: "W", as: "W_prettyvalue", period }],
    ["valuewithoutsymbol", { series: "W", as: "W_valuewithoutsymbol", period }],
    ["unit", { series: "W", as: "W_unit", period }],

    // Initiative series
    ["value", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE", period }],
    ["prettyvalue", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_prettyvalue", period }],
    ["unit", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_unit", period }],
    ["unitname", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_unitname", period }],
    ["valuewithoutsymbol", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_valuewithoutsymbol", period }],

    ["value", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION", period }],
    ["prettyvalue", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_prettyvalue", period }],
    ["unit", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_unit", period }],
    ["valuewithoutsymbol", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_valuewithoutsymbol", period }],

    ["value", { series: "BUDGET", as: "BUDGET", period }],
    ["prettyvalue", { series: "BUDGET", as: "BUDGET_prettyvalue", period }],
    ["value", { series: "BUDGET_UTIL", as: "BUDGET_UTIL", period }],
    ["prettyvalue", { series: "BUDGET_UTIL", as: "BUDGET_UTIL_prettyvalue", period }],
    ["prettyvalue", { series: "EXPENDITURE", as: "EXPENDITURE_prettyvalue", period }],

    ["value", { series: "START_DATE", as: "START_DATE", period }],
    ["value", { series: "END_DATE", as: "END_DATE", period }],
    ["value", { series: "ACTUAL_START_DATE", as: "ACTUAL_START_DATE", period }],
    ["value", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE", period }],
    
    ["prettyvalue", { series: "START_DATE", as: "START_DATE_prettyvalue", period }],
    ["prettyvalue", { series: "END_DATE", as: "END_DATE_prettyvalue", period }],
    ["prettyvalue", { series: "ACTUAL_START_DATE", as: "ACTUAL_START_DATE_prettyvalue", period }],
    ["prettyvalue", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE_prettyvalue", period }],

    ["value", { series: "SLIPPAGE", as: "SLIPPAGE", period }],
    ["prettyvalue", { series: "SLIPPAGE", as: "SLIPPAGE_prettyvalue", period }],
    ["unit", { series: "SLIPPAGE", as: "SLIPPAGE_unit", period }],
    ["valuewithoutsymbol", { series: "SLIPPAGE", as: "SLIPPAGE_valuewithoutsymbol", period }],

    ["value", { series: "VARIANCE", as: "VARIANCE", period }],
    ["prettyvalue", { series: "VARIANCE", as: "VARIANCE_prettyvalue", period }],
    ["unit", { series: "VARIANCE", as: "VARIANCE_unit", period }],
    ["valuewithoutsymbol", { series: "VARIANCE", as: "VARIANCE_valuewithoutsymbol", period }],

    ["value", { series: "EXPENDITURE", as: "EXPENDITURE", period }],
    ["unit", { series: "EXPENDITURE", as: "EXPENDITURE_unit", period }],
    ["unitname", { series: "EXPENDITURE", as: "EXPENDITURE_unitname", period }],
    ["valuewithoutsymbol", { series: "EXPENDITURE", as: "EXPENDITURE_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "EXPENDITURE", as: "EXPENDITURE_prettyvalue", period }],

    // KPIs series
    ["value", { series: "PERF_W", as: "PERF_W", period }],
    ["prettyvalue", { series: "PERF_W", as: "PERF_W_prettyvalue", period }],
    ["value", { series: "ACT", as: "ACT", period }],
    ["value", { series: "TAR", as: "TAR", period }],
    ["unit", { series: "ACT", as: "ACT_unit", period }],
    ["unit", { series: "TAR", as: "TAR_unit", period }],
    ["unitname", { series: "ACT", as: "ACT_unitname", period }],
    ["unitname", { series: "TAR", as: "TAR_unitname", period }],
    ["valuewithoutsymbol",{ series: "ACT", as: "ACT_valuewithoutsymbol", period }],
    ["valuewithoutsymbol",{ series: "TAR", as: "TAR_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "ACT", as: "ACT_prettyvalue", period }],
    ["prettyvalue", { series: "TAR", as: "TAR_prettyvalue", period }],
  ];

 if(lastPeriod) {
  items.push(  ["prettyvalue", { series: "TAR_YTD", as: "TAR_YEAR_END_YTD_prettyvalue", period:lastPeriod?.name || 'latestforseries' }] )
 } else {
  items.push(  ["prettyvalue", { series: "TAR_YTD", as: "TAR_YEAR_END_YTD_prettyvalue", period: '12 / 2023' }] )

 }

 return items as any;
}

export default defaultAttributes;
